import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1065SchB1 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Schedule B-1 (Form 1065) Instructions for 50% Partnership Owners"
          description="Learn who must file Schedule B-1 (Form 1065), what ownership information to report, and how to complete Parts I and II for owners with 50% or more interests"
          keywords=""
          canonical="resources/business-tax/schedule-b-1-form-1065-instruction/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 2,
            mt: 5,
            textAlign: 'center',
          }}
        >
          {' '}
          <span className="highlight-container">
            <span className="highlight">Schedule B-1</span>
          </span>{' '}
          (Form 1065): Partners Owning 50% or More
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 5,
          }}
        >
          Learn who must be reported on Schedule B-1 and how to provide
          information <br /> about partners who own 50% or more of the
          partnership.
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-b-1-form-1065-instruction/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule B-1 (Form 1065) at a Glance
                  </Typography>

                  <Box
                    component="ul"
                    itemProp="articleBody"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of Schedule B-1 (Form 1065)
                        </strong>{' '}
                        and how partnerships use it to report individuals,
                        estates, and entities that directly or indirectly own
                        50% or more of the partnership’s profit, loss, or
                        capital.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Schedule B-1 step by step,
                        </strong>{' '}
                        including Part I for entities and Part II for
                        individuals or estates, along with ownership percentages
                        and required identification information.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand how Schedule B-1 identifies direct and
                          indirect ownership interests
                        </strong>{' '}
                        and how the reported information helps ensure accurate
                        ownership reporting and compliance with Form 1065 filing
                        requirements.
                      </span>
                    </li>
                  </Box>
                </Box>

                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What is IRS Schedule B-1 (Form 1065)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#info" sx={{ color: '#0202ff' }}>
                          What Information Is Reported on Schedule B-1?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#howschb" sx={{ color: '#0202ff' }}>
                          How Schedule B-1 Differs from Other Form 1065
                          Schedules?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must File Schedule B-1?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#filing" sx={{ color: '#0202ff' }}>
                          Filing Deadlines
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#step" sx={{ color: '#0202ff' }}>
                          Step-by-Step Instruction for Schedule B-1 (Form 1065)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#part1" sx={{ color: '#0202ff' }}>
                          Part I – Entities Owning 50% or More
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#part2" sx={{ color: '#0202ff' }}>
                          Part II – Individuals or Estates Owning 50% or More
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#family" sx={{ color: '#0202ff' }}>
                          Family Attribution Rules
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#filingtips" sx={{ color: '#0202ff' }}>
                          Important Filing Tips
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#best" sx={{ color: '#0202ff' }}>
                          Best Practices for Schedule B-1 Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What is IRS Schedule B-1 (Form 1065)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule B-1 (Form 1065) is an IRS attachment used to report
                  individuals, entities, or estates that directly or indirectly
                  own 50% or more of a partnership’s profit, loss, or capital.
                  Partnerships must attach this schedule to Form 1065 when they
                  answer <strong style={{ fontWeight: 600 }}> “Yes”</strong> to
                  specific ownership questions in Schedule B.
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  The form helps the IRS identify major owners and track
                  ownership structures involving corporations, partnerships,
                  trusts, tax-exempt organizations, foreign governments,
                  individuals, and estates.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="info"
                >
                  What Information is Reported on Schedule B-1?
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  The schedule requires partnerships to disclose:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Name of each 50% or greater owner</li>
                  <li>Identifying number (SSN or EIN) </li>
                  <li>
                    Type of owner (individual, corporation, partnership, trust,
                    estate, etc.)
                  </li>
                  <li>Country of citizenship or organization </li>
                  <li>
                    Percentage of ownership in profits, losses, or capital{' '}
                  </li>
                  <li>Direct and indirect ownership relationships</li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS uses Schedule B-1 to track ownership concentration and
                  verify related-party reporting obligations.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  The schedule is divided into two parts:
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Part I –</strong>{' '}
                    Reports entities such as corporations, partnerships, trusts,
                    tax-exempt organizations, and foreign governments.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Part II – </strong>
                    Reports individuals and estates.
                  </li>
                  <li>
                    A partnership must complete this form if any owner holds 50%
                    or more of the partnership’s profit, loss, or capital at the
                    end of the tax year.
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="howschb"
                >
                  How Schedule B-1 Differs from Other Form 1065 Schedules?
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 100,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Schedule
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            What It Reports
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Schedule B-1
                          </TableCell>
                          <TableCell>
                            Information about partners owning 50% or more of the
                            partnership
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Schedule B
                          </TableCell>

                          <TableCell>
                            Other Information about the partnership, accounting
                            methods, and tax questions
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Schedule B-2
                          </TableCell>

                          <TableCell>
                            Election Out of the Centralized Partnership Audit
                            Regime
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Schedule K
                          </TableCell>

                          <TableCell>
                            Total partnership income, deductions, credits, and
                            other items
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Schedule K-1
                          </TableCell>

                          <TableCell>
                            Each partner’s distributive share of partnership
                            items
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Schedule L
                          </TableCell>

                          <TableCell>
                            Partnership balance sheet per books
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Schedule M-1
                          </TableCell>

                          <TableCell>
                            Reconciliation of book income with taxable income
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Schedule M-2
                          </TableCell>

                          <TableCell>
                            Analysis of partners’ capital accounts
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must File Schedule B-1?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  A partnership filing Form 1065 must complete Schedule B-1 if:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Any partner owned directly or indirectly 50% or more of:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>The partnership’s profit interest,</li>
                  <li>Loss interest, or</li>
                  <li>Capital interest at any time during the tax year. </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This requirement applies to:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>Individuals</li>
                  <li>Corporations</li>
                  <li>Partnerships </li>
                  <li>LLCs</li>
                  <li>Trusts</li>
                  <li>Estates</li>
                  <li>Nominees or disregarded entities </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Indirect ownership rules apply, meaning ownership through
                  another entity may still require disclosure.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="filing"
                >
                  Filing Deadlines
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule B-1 must be attached to Form 1065 and filed by the
                  partnership’s tax return due date.
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Entity Type
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Filing Deadline (Tax Year 2025)
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Partnerships
                          </TableCell>
                          <TableCell>Form 1065</TableCell>
                          <TableCell>March 16, 2026</TableCell>
                          <TableCell>Form 7004</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="step"
                >
                  Step-by-Step Instruction for Schedule B-1 (Form 1065)
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Basic Information
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Before completing Schedule B-1, provide the partnership's
                  identifying information at the top of the form.
                </Typography>

                <picture>
                  <source srcSet="/assets/images/f1065-schb1-img.webp" />
                  <source srcSet="/assets/images/f1065-schb1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1065-schb1-img.png"
                    loading="lazy"
                    alt="Schedule B-1 (Form 1065) basic information showing partnership name and EIN"
                    width={760}
                    height={125}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Name of Partnership –
                  </strong>{' '}
                  Enter the partnership's legal name exactly as it appears on
                  Form 1065 and IRS records.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Employer Identification Number (EIN) –
                  </strong>{' '}
                  Enter the partnership's IRS-issued nine-digit EIN exactly as
                  reported on Form 1065.
                </Typography>
                <Alert
                  severity="info"
                  id="who"
                  icon={false}
                  sx={{ mb: 4, borderLeft: '3px solid #0288d1' }}
                >
                  <b>Tip:</b>{' '}
                  <i>
                    Use the partnership's legal name and correct EIN exactly as
                    reported on Form 1065 and IRS records to avoid processing
                    delays or IRS notices.{' '}
                  </i>
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="part1"
                >
                  Part I – Entities Owning 50% or More
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  Complete Part I if an entity directly or indirectly owns at
                  least 50% of the partnership.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1065-schb1-part1-img.webp" />
                  <source srcSet="/assets/images/f1065-schb1-part1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1065-schb1-part1-img.png"
                    loading="lazy"
                    alt="Schedule B-1 Part I showing entity name, type, country, and ownership percentage for entities owning 50% or more"
                    width={760}
                    height={367}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Coumn1 – Name of Entity Owner
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the full legal name of the corporation, partnership,
                  trust, tax-exempt organization, or foreign government that
                  owns 50% or more of the partnership.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  ABC Holdings Inc.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 2 – Employer Identification Number (EIN)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the entity’s EIN exactly as assigned by the IRS.{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  12-3456789
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 3 – Type of Entity
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Specify the type of owner entity.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Common entity types include:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>Corporation </li>
                  <li>Partnership</li>
                  <li>Trust </li>
                  <li>Tax-Exempt Organization </li>
                  <li>Foreign Government </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the owner is tax-exempt, enter{' '}
                  <strong style={{ fontWeight: 600 }}>
                    Tax-Exempt Organization
                  </strong>
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 4 – Country of Organization
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the country where the entity was legally organized or
                  formed.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the entity was formed in the United States, enter{' '}
                  <strong style={{ fontWeight: 600 }}> United States</strong>
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 5 – Maximum Percentage Owned
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the highest percentage of profit, loss, or capital owned
                  directly or indirectly during the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  If a corporation owns:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>40% directly, and</li>
                  <li>20% indirectly through another partnership, </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  the total ownership is 60%, enter{' '}
                  <strong style={{ fontWeight: 600 }}> 60% </strong>
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="part2"
                >
                  Part II – Individuals or Estates Owning 50% or More
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Complete Part II if an individual or estate directly or
                  indirectly owns at least 50% of the partnership.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1065-schb1-part2-img.webp" />
                  <source srcSet="/assets/images/f1065-schb1-part2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1065-schb1-part2-img.png"
                    loading="lazy"
                    alt="Schedule B-1 Part II showing name, identifying number, ownership type, and percentage for individuals or estates owning 50% or more"
                    width={760}
                    height={352}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 1 – Name of Individual or Estate
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the full name of the individual or estate owner.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  John Smith or Estate of Robert Miller
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 2 – SSN or EIN
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the Social Security Number (SSN) for individuals or
                  Employer Identification Number (EIN) for estates.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  123-45-6789
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 3 – Country of Citizenship
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the country of citizenship for the individual. For
                  estates, enter the citizenship of the decedent.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  United States
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 4 – Maximum Percentage Owned
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the highest percentage of profit, loss, or capital owned
                  directly or indirectly during the year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  If an individual owns 50% of the partnership, enter{' '}
                  <strong style={{ fontWeight: 600 }}> 50%</strong>
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="family"
                >
                  Family Attribution Rules
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Family ownership is not automatically attributed unless the
                  family member directly owns an interest or indirectly owns an
                  interest through another entity.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  A owns 50% of Partnership X.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  B, A’s daughter, owns no direct or indirect interest.
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Partnership X reports A on Schedule B-1 but does not report B
                  because family attribution rules do not apply in this
                  situation.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="filingtips"
                >
                  Important Filing Tips
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>Report both direct and indirect ownership interests. </li>
                  <li>
                    Use the parent corporation for consolidated groups instead
                    of subsidiaries.
                  </li>
                  <li>
                    Report the owner of a disregarded entity rather than the
                    disregarded entity itself.
                  </li>
                  <li>Attach Schedule B-1 to Form 1065 when required. </li>
                  <li>
                    Ensure ownership percentages are calculated correctly before
                    filing.{' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Mistakes to Avoid
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Mistake
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Impact
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Failing to report indirect ownership
                          </TableCell>
                          <TableCell>IRS penalties or audit risk </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Omitting a 50% owner</TableCell>
                          <TableCell>Incomplete return filing </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Incorrect ownership percentages</TableCell>
                          <TableCell>
                            IRS notices and amended filings{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Missing EIN or SSN information</TableCell>
                          <TableCell>Processing delays</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Not attaching Schedule B-1 when required
                          </TableCell>
                          <TableCell>
                            Return rejection or compliance issues
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="best"
                >
                  Best Practices for Schedule B-1
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Maintain updated ownership records throughout the year.
                  </li>
                  <li>
                    Track changes in profit, loss, and capital ownership
                    percentages.
                  </li>
                  <li>
                    Review partnership agreements for ownership allocations.
                  </li>
                  <li>Verify indirect ownership structures carefully.</li>
                  <li>
                    Ensure Schedule B-1 information matches Schedule K-1 and
                    other partnership filings.
                  </li>
                  <li>
                    Use automated tax filing software like TaxZerone to simplify
                    Form 1065 filing and attachment preparation.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What is the purpose of Schedule B-1 (Form 1065)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule B-1 (Form 1065) is used to report individuals,
                  estates, and entities that directly or indirectly own{' '}
                  <strong style={{ fontWeight: 600 }}> 50% or more</strong> of a
                  partnership’s profit, loss, or capital. The IRS uses this
                  information to identify significant ownership interests in
                  partnerships and related entities.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Who must file Schedule B-1 (Form 1065)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  A partnership must file Schedule B-1 if it answers{' '}
                  <strong style={{ fontWeight: 600 }}>“Yes”</strong> to Question
                  2a or 2b of Schedule B (Form 1065). The schedule is required
                  when an entity, individual, or estate owns, directly or
                  indirectly,{' '}
                  <strong style={{ fontWeight: 600 }}>50% or more</strong> of
                  the partnership's profit, loss, or capital at the end of the
                  tax year. Schedule B-1 must be attached to Form 1065.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. Where can I find Schedule B-1 (Form 1065) instructions?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  You can find Schedule B-1 (Form 1065) instructions on the
                  official IRS website or through tax filing platforms such as
                  TaxZerone, which provide e-filing support and access to
                  partnership tax forms, including Form 1065 and Schedule B-1.
                  The instructions cover filing requirements, ownership
                  reporting rules, direct and indirect ownership calculations,
                  and guidance for completing Parts I and II of the schedule.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. What happens if Schedule B-1 (Form 1065) is not filed?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If a partnership is required to file Schedule B-1 but fails to
                  do so, the IRS may consider the partnership return incomplete.
                  This can lead to IRS notices, requests for additional
                  information, delays in processing the return, and potential
                  penalties if the omission affects the partnership's filing
                  compliance.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. Is Schedule B-1 (Form 1065) filed separately?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Schedule B-1 is not filed separately. It must be completed
                  and attached to{' '}
                  <strong style={{ fontWeight: 600 }}>
                    Form 1065, U.S. Return of Partnership Income,
                  </strong>
                  when the partnership answers "Yes" to the applicable ownership
                  questions on Schedule B.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  6. Who should be reported on Schedule B-1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report any entity, individual, or estate that directly or
                  indirectly owns{' '}
                  <strong style={{ fontWeight: 600 }}>50% or more</strong> of
                  the partnership's profit, loss, or capital at the end of the
                  tax year.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      {/* <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with Schedule K-1 Using TaxZerone
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure each shareholder’s income, deductions, and credits are
              accurately reported and IRS-compliant.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=schk1`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container> */}
    </AppLayout>
  );
};

export default Form1065SchB1;
